import { Injectable } from "@angular/core";
import { DataService } from "../data.service";
import { BillingCloseSearchItem } from "../../model/billing/billing-close-search-item";
import { BillingClosePreBilling } from "../../model/billing/billing-close-pre-billing";

@Injectable({
  providedIn: "root",
})
export class BillingCloseService {
  constructor(private dataService: DataService) {}

  private readonly getBillingCloseSearchItemsEndPoint: string =
    "/billingClose/getBillingCloseSearchItems/";
  private readonly billingOrderControlStateChangeEndPoint: string =
    "/billingClose/billingOrderControlStateChange/";
  private readonly billingOrderControlStateRollBackEndPoint: string =
    "/billingClose/billingOrderControlStateRollBack/";
  private readonly getBillingClosePreBillingsEndPoint: string =
    "/billingClose/getBillingClosePreBillings/";
  private readonly billingOrderControlPreBillEndPoint: string =
    "/billingClose/billingOrderControlPreBill/";

  async getBillingClosePreBillings(
    medicalAppointmentProcedureIds: number[]
  ): Promise<BillingClosePreBilling[]> {
    console.log(JSON.stringify(medicalAppointmentProcedureIds));
    // const params = { medicalAppointmentProcedureIds: JSON.stringify(medicalAppointmentProcedureIds) };
    const params = {
      medicalAppointmentProcedureIds: medicalAppointmentProcedureIds,
    };
    return await this.dataService
      .post<BillingClosePreBilling[]>(
        this.getBillingClosePreBillingsEndPoint,
        params
      )
      .toPromise();
  }

  async getBillingCloseSearchItems(
    planIds: number[],
    from: Date,
    to: Date,
    protocol: string,
    aliquotTaxIds: number[],
    serviceIds: number[],
    billingStateIds: number[],
    nobillinoBillingReasonIds: number[],
    branchIds: number[],
    patientId: number | null,
    practiceId: number | null,
    equipmentId: number | null,
    specialityId: number | null,
    atLeastOneInformed: boolean,
    orderByPatient: boolean,
    seeTotals: boolean,
    sectorId?: number
  ): Promise<BillingCloseSearchItem[]> {
    const params = {
      from: new Date(
        from.getFullYear(),
        from.getMonth(),
        from.getDate()
      ).toDateString(),
      to: new Date(
        to.getFullYear(),
        to.getMonth(),
        to.getDate()
      ).toDateString(),
      complete: seeTotals,
      atLeastOneInformed: atLeastOneInformed,
      planIds: planIds ? JSON.stringify(planIds) : "",
      protocol: protocol,
      aliquotTaxIds: aliquotTaxIds ? JSON.stringify(aliquotTaxIds) : "",
      serviceIds: serviceIds ? JSON.stringify(serviceIds) : "",
      billingStateIds: billingStateIds ? JSON.stringify(billingStateIds) : "",
      nobillinoBillingReasonIds: nobillinoBillingReasonIds
        ? JSON.stringify(nobillinoBillingReasonIds)
        : "",
      branchIds: branchIds ? JSON.stringify(branchIds) : "",
      patientId: patientId,
      practiceId: practiceId,
      equipmentId: equipmentId,
      specialityId: specialityId,
      orderByPatient,
      sectorId: sectorId,
    };

    return await this.dataService
      .post<BillingCloseSearchItem[]>(
        this.getBillingCloseSearchItemsEndPoint,
        params
      )
      .toPromise();
  }

  async billingOrderControlStateChange(
    medicalAppointmentProcedureIds: number[],
    billingStateId: number,
    noBillingReasonId?: number,
    observations?: string
  ): Promise<boolean> {
    const params = {
      medicalAppointmentProcedureIds: medicalAppointmentProcedureIds,
      billingStateId: billingStateId,
      observations: observations,
      noBillingReasonId: noBillingReasonId,
    };
    return await this.dataService
      .post<boolean>(this.billingOrderControlStateChangeEndPoint, params)
      .toPromise();
  }

  async billingOrderControlPreBill(
    billingClosePreBillings: BillingClosePreBilling[]
  ): Promise<boolean> {
    const params = { BillingClosePreBillings: billingClosePreBillings };
    return await this.dataService
      .post<boolean>(this.billingOrderControlPreBillEndPoint, params)
      .toPromise();
  }

  async billingOrderControlStateRollBack(
    medicalAppointmentProcedureIds: number[]
  ): Promise<boolean> {
    const params = {
      medicalAppointmentProcedureIds: medicalAppointmentProcedureIds,
    };
    return await this.dataService
      .post<boolean>(this.billingOrderControlStateRollBackEndPoint, params)
      .toPromise();
  }
}
